/**
 * @generated SignedSource<<484fd7fef369b6ade30fe6cb89abc829>>
 * @relayHash efe9f1db11e6de328e9f1549d3bf2dda
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 615b7ed663144eb1919951d271557951faf2fdb21681d222dc88fedad6aa9908

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type providersListTooltipContentQuery$variables = {
  cloudId: string;
};
export type providersListTooltipContentQuery$data = {
  readonly devOps: {
    readonly providers: {
      readonly deploymentProviders: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"providerLogo_softwareReleasesLaunchCard">;
      } | null | undefined>;
    };
  };
};
export type providersListTooltipContentQuery = {
  response: providersListTooltipContentQuery$data;
  variables: providersListTooltipContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "providerTypes",
    "value": [
      "DEPLOYMENT"
    ]
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "providersListTooltipContentQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "DevOps",
          "kind": "LinkedField",
          "name": "devOps",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "DevOpsDeploymentProvider",
                      "kind": "LinkedField",
                      "name": "deploymentProviders",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v2/*: any*/),
                          "action": "THROW",
                          "path": "devOps.providers.deploymentProviders.id"
                        },
                        {
                          "kind": "RequiredField",
                          "field": (v3/*: any*/),
                          "action": "THROW",
                          "path": "devOps.providers.deploymentProviders.name"
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "providerLogo_softwareReleasesLaunchCard"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "devOps.providers.deploymentProviders"
                  }
                ]
              },
              "action": "THROW",
              "path": "devOps.providers"
            }
          ]
        },
        "action": "THROW",
        "path": "devOps"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "providersListTooltipContentQuery",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "DevOpsProviders",
            "kind": "LinkedField",
            "name": "providers",
            "plural": false,
            "selections": [
              {
                "concreteType": "DevOpsDeploymentProvider",
                "kind": "LinkedField",
                "name": "deploymentProviders",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "logoUrl"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "615b7ed663144eb1919951d271557951faf2fdb21681d222dc88fedad6aa9908",
    "metadata": {},
    "name": "providersListTooltipContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2fb2dcefa503b43df945cc594382beab";

export default node;
